import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, InjectionToken, Provider } from '@angular/core';
import { merge } from 'lodash';
import { firstValueFrom, map, ReplaySubject, share } from 'rxjs';
import { environment } from '../environments/environment';
import { Environment } from '../environments/environment.model';

export const ENVIRONMENT = new InjectionToken('env');
const environmentSubject = new ReplaySubject<Environment>(1);
const environment$ = environmentSubject.asObservable();

type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object
    ? RecursivePartial<T[P]>
    : T[P];
};

export const ENVIRONMENT_INITIALIZER: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: environmentInitializer,
    multi: true,
    deps: [HttpClient],
  },
  { provide: ENVIRONMENT, useValue: environment$ },
];

export function environmentInitializer(
  http: HttpClient
): () => Promise<RecursivePartial<Environment>> {
  return (): Promise<RecursivePartial<Environment>> => {
    const env$ = http.get<Environment>('/assets/environment.json').pipe(
      share(),
      map((e) => merge(environment, e))
    );

    env$.subscribe(environmentSubject);

    return firstValueFrom(env$);
  };
}
